import { useState } from "react";

export default function ContactForm() {
  const [form, setForm] = useState({ email: "", phone: "", message: "" });
  const [status, setStatus] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("Envoi…");

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        setStatus("Message envoyé ✅");
        setForm({ email: "", phone: "", message: "" });
      } else {
        setStatus("Erreur: " + data.error);
      }
    } catch (err) {
      setStatus("Erreur réseau");
    }
  }

  return (
    <section className="form-section sansita" id="form">
      <div className="form-section-infos f24">
        <div className="infos-container">
          <div className="email info">
            <img src="./img/form/email.png" alt="icon instagram" />
            <a href="mailto:contact@maestrom-digital.fr">contact@maestrom-digital.fr</a>
          </div>
          <div className="insta info">
            <img src="./img/form/insta.png" alt="icon instagram" />
            <a href="https://www.instagram.com/maestromdigital/">@maestromdigital</a>
          </div>
        </div>
        <p>Maestrom Agence web</p>
      </div>
      <div className="form-section-text">
        <h2 className="f48 sansita">Travaillons ensemble</h2>
        <p className="f24">Décrivez votre projet et laissez vos informations de contact. Vous serez contacté très bientôt ! </p>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: 400 }}>
          <label className="f36">
            <span className="sansita">Email </span><br />
            <input
              className="f20"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </label>

          <label className="f36">
            <span className="sansita">Téléphone <span className="f16">(facultatif)</span></span>
            <input
              className="f20"
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
          </label>

          <label className="f36">
           <span className="sansita">Message</span>
            <textarea
              className="f20 karrik"
              name="message"
              value={form.message}
              onChange={handleChange}
              required
            />
          </label>

          <button
            onClick={() =>
              window.gtag("event", "submit_form", {
                button_id: "submit_button",
              })
            }
            className="btn-form f24"
            type="submit"
          >
            Envoyer
          </button>
          {status && <p>{status}</p>}
        </form>
      </div>
    </section>
  );
}
